import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import dashboardTheme from './Components/DashboardTheme/DashboardTheme';
import NavBar from './Components/NavBar/NavBar';
import HomePage from './Pages/HomePage/HomePage';
import BagPage from './Pages/BagPage/BagPage';
import PadPage from './Pages/PadPage/PadPage';
import SparringPage from './Pages/SparringPage/SparringPage';
import NextGala from './Pages/NextGalà/NextGalà';
import StoryVivenzioGym from './Pages/StoryVivenzioGym/StoryVivenzioGym';
import FightsHistoryPage from './Pages/RingSide/FightsHistoryPage/FightsHistoryPage';
import './App.css';

/** Every route change should start at the top of the new page. */
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <ThemeProvider theme={dashboardTheme}>
      <CssBaseline />
      <BrowserRouter>
        <ScrollToTop />
        <NavBar />
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/bagPage' element={<BagPage />} />
          <Route path='/padPage' element={<PadPage />} />
          <Route path='/sparringPage' element={<SparringPage />} />
          <Route path='/nextGalà' element={<NextGala />} />
          <Route path='/storyVivenzioGym' element={<StoryVivenzioGym />} />
          <Route path='/fightsHistoryPage' element={<FightsHistoryPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
